import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { login } from '../../api'
import actions from './actions'

function* LOAD({ payload: { params } }) {
  yield put(request(login(params), actions.LOAD))
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD), takeEvery('login', LOAD)])
}
